//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    customer_id: number;
    requestBody: {
        addressLine1: string;
        addressLine2?: null | undefined | string;
        bankAccountNumber?: null | undefined | string;
        bankAccountSortCode?: null | undefined | string;
        birthDate: string;
        city?: null | undefined | string;
        country: string;
        county?: null | undefined | string;
        email: string;
        externalId?: null | undefined | string;
        firstName: string;
        fullName?: null | undefined | string;
        landlinePhone?: null | undefined | {
            country: string;
            number: string;
            prefix: string;
        };
        mobilePhone: {
            country: string;
            number: string;
            prefix: string;
        };
        personalId?: null | undefined | string;
        postCode: string;
        surname: string;
        telebettingId?: null | undefined | string;
        telebettingPassword?: null | undefined | string;
        title: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/customer/{customer_id}/personal-details -> patch -> ${code}`);
    };
};

export const Response200IO = t.union([t.interface({
    errors: t.interface({
        errors: t.array(t.interface({
            code: t.string,
            debugDetails: t.string,
            field: t.string,
            resource: t.string,
        })),
    }),
    status: t.literal('422'),
    type: t.literal('PersonalDetailsPatchErrorResponse'),
}), t.interface({
    status: t.literal('200'),
    type: t.literal('PersonalDetailsPatchSuccessResponse'),
})]);
export type Response200Type = {
    errors: {
        errors: Array<{
            code: string;
            debugDetails: string;
            field: string;
            resource: string;
        }>;
    };
    status: '422';
    type: 'PersonalDetailsPatchErrorResponse';
} | {
    status: '200';
    type: 'PersonalDetailsPatchSuccessResponse';
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffPatchUserPersonalDetailRequest"
 */
export const openapi_proxy_staff_patch_user_personal_detail = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/customer/${params.customer_id}/personal-details${query}`;
    
    const method = 'PATCH';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffPatchUserPersonalDetailParamsType = ParamsType;

export type OpenapiProxyStaffPatchUserPersonalDetailResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffPatchUserPersonalDetailResponse200Type = Response200Type;

export const openapiProxyStaffPatchUserPersonalDetailRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffPatchUserPersonalDetailResponseType> => {
    const response = await openapi_proxy_staff_patch_user_personal_detail(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffPatchUserPersonalDetailRequest - unhandled response ${response.status}`);
};

